module.exports = __webpack_public_path__ + "img/lk_events_empty_2.8bf12237.svg";